import { Notification, NotificationTypes } from '@generated/queries';
import { Expose } from 'class-transformer';
import { User } from './user/user';

export class NotificationModel  {
  @Expose() id: string | undefined;
  @Expose() userId: string | undefined;
  @Expose() isRead: boolean | undefined;
  @Expose() message: string | undefined;
  @Expose() createdOn: Date | undefined;
  @Expose() type: NotificationTypes | undefined;
  @Expose() systemObject: string | undefined;
  @Expose() systemObjectId: string | undefined;
  @Expose() user?: User | undefined;
}
